<!--
Another
其他
-->


<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="其他" name="其他">
        <el-row>
          <el-col :span="24">
            <el-form :label-position="labelPosition" :model="another">
              <el-form-item label="">
                <p>需求描述</p>
                <el-input type="textarea" v-model="another['需求描述']" placeholder="请尽量清楚的文字描述您的所使用的材料，尺寸，特殊工艺，款式和理想中成品的样子等需求"></el-input>
              </el-form-item>
              <center>
                <el-button v-on:click="addEvent()">提交</el-button> <el-button v-on:click="clear()">清空</el-button> 
              </center>
              
            </el-form>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
export default {
  name: "Another",
  data() {
    return {
      forcollapse: ['allsame'],
      another: {
        title: "其他",
      },
      labelPosition: "left"
    };
  },
  methods: {
    addEvent() {
      this.$root.add(this.another);
       
    },
    clear() {
      this.$root.clearAlert()
      this.another = {
        title: "其他",
      };
    }
  }
};
</script>
<style scoped>
</style>